import { LinkButton } from '@cian/ui-kit';

import { type ComponentProps, type FC } from 'react';

import styles from './PikLinkButton.css';

type PikLinkButtonProps = Omit<ComponentProps<typeof LinkButton>, 'theme'>;

export const PikLinkButton: FC<PikLinkButtonProps> = props => (
  <span className={styles['container']}>
    <LinkButton {...props} theme="warning_primary" />
  </span>
);
